module.exports = __webpack_public_path__ + "static/media/Github-octicon.6582a7d9.svg";